var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTraderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trader_icon",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M19.5,44H39.333V41.667H19.5A1.168,1.168,0,0,1,18.333,40.5v-21A1.168,1.168,0,0,1,19.5,18.333H46.333A1.168,1.168,0,0,1,47.5,19.5V34.667h2.333V19.5a3.5,3.5,0,0,0-3.5-3.5H19.5A3.5,3.5,0,0,0,16,19.5v21A3.5,3.5,0,0,0,19.5,44Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M133.175,199.754l-2.389-6.37a5.833,5.833,0,0,0-4.047-3.611l-6.277-1.569-.555-2.22a3.493,3.493,0,0,0-2.74-2.588v-1.23a1.172,1.172,0,0,1,.467-.933l.466-.35a9.378,9.378,0,0,0,3.733-7.467v-4.083a9.333,9.333,0,0,0-18.667,0v4.083a9.377,9.377,0,0,0,3.733,7.467l.467.35a1.172,1.172,0,0,1,.467.933v1.23a3.493,3.493,0,0,0-2.74,2.588l-.555,2.22-6.277,1.569a5.833,5.833,0,0,0-4.047,3.611l-2.389,6.37A8.166,8.166,0,0,0,88,206.667V209h49v-2.333A8.166,8.166,0,0,0,133.175,199.754ZM105.5,173.417v-4.083a7,7,0,1,1,14,0v4.083a7.033,7.033,0,0,1-2.8,5.6l-.466.35a3.516,3.516,0,0,0-1.4,2.8v1.167h-4.667v-1.167a3.516,3.516,0,0,0-1.4-2.8l-.467-.35A7.033,7.033,0,0,1,105.5,173.417Zm2.988,12.25h8.023a1.165,1.165,0,0,1,1.132.884l.362,1.45H106.994l.362-1.45a1.165,1.165,0,0,1,1.132-.884ZM96.4,194.2a3.5,3.5,0,0,1,2.428-2.167l6.816-1.7h13.713l6.817,1.7A3.5,3.5,0,0,1,128.6,194.2l1.659,4.423a8.175,8.175,0,0,0-1.427-.127H96.167a8.174,8.174,0,0,0-1.427.127Zm-6.065,12.463a5.84,5.84,0,0,1,5.833-5.833h32.667a5.84,5.84,0,0,1,5.833,5.833Z",
    transform: "translate(-61.5 -123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M30,247.333H19.5a1.168,1.168,0,0,1-1.167-1.167V227.5a1.168,1.168,0,0,1,1.167-1.167H39.333V224H19.5a3.5,3.5,0,0,0-3.5,3.5v18.667a3.5,3.5,0,0,0,3.5,3.5H30Z",
    transform: "translate(0 -177.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M294.333,16H267.5a3.5,3.5,0,0,0-3.5,3.5V34.667h2.333V19.5a1.168,1.168,0,0,1,1.167-1.167h26.833A1.168,1.168,0,0,1,295.5,19.5v21a1.168,1.168,0,0,1-1.167,1.167H274.5V44h19.833a3.5,3.5,0,0,0,3.5-3.5v-21A3.5,3.5,0,0,0,294.333,16Z",
    transform: "translate(-211.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M355.833,224H336v2.333h19.833A1.168,1.168,0,0,1,357,227.5v18.667a1.168,1.168,0,0,1-1.167,1.167h-10.5v2.333h10.5a3.5,3.5,0,0,0,3.5-3.5V227.5A3.5,3.5,0,0,0,355.833,224Z",
    transform: "translate(-273.333 -177.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M48,56h5.833v2.333H48Z",
    transform: "translate(-27.333 -34.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M112,56h5.833v2.333H112Z",
    transform: "translate(-82 -34.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M176,56h5.833v2.333H176Z",
    transform: "translate(-136.667 -34.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M48,88h5.833v2.333H48Z",
    transform: "translate(-27.333 -61.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M112,88h5.833v2.333H112Z",
    transform: "translate(-82 -61.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M176,88h5.833v2.333H176Z",
    transform: "translate(-136.667 -61.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M48,152h5.833v2.333H48Z",
    transform: "translate(-27.333 -116.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M112,152h5.833v2.333H112Z",
    transform: "translate(-82 -116.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M176,152h4.667v2.333H176Z",
    transform: "translate(-136.667 -116.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M48,120h5.833v2.333H48Z",
    transform: "translate(-27.333 -88.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M112,120h5.833v2.333H112Z",
    transform: "translate(-82 -88.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M176,120h5.833v2.333H176Z",
    transform: "translate(-136.667 -88.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M291.993,78.493,297,73.484l3.5,3.5,5.833-5.833,3.5,3.5,6.658-6.658-1.65-1.65-5.008,5.008-3.5-3.5L300.5,73.685l-3.5-3.5-6.658,6.658Z",
    transform: "translate(-234.335 -43.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M296,48h7v2.333h-7Z",
    transform: "translate(-239.167 -27.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M336,160h4.667v2.333H336Z",
    transform: "translate(-273.333 -123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M384,160h4.667v2.333H384Z",
    transform: "translate(-314.333 -123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M432,160h4.667v2.333H432Z",
    transform: "translate(-355.333 -123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M48,256h5.833v2.333H48Z",
    transform: "translate(-27.333 -205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M112,256h9.333v2.333H112Z",
    transform: "translate(-82 -205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M48,288h5.833v2.333H48Z",
    transform: "translate(-27.333 -232.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M112,288h9.333v2.333H112Z",
    transform: "translate(-82 -232.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M48,352h5.833v2.333H48Z",
    transform: "translate(-27.333 -287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M112,352h3.5v2.333H112Z",
    transform: "translate(-82 -287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M48,320h5.833v2.333H48Z",
    transform: "translate(-27.333 -259.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M112,320h9.333v2.333H112Z",
    transform: "translate(-82 -259.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M448,256h2.333v2.333H448Z",
    transform: "translate(-369 -205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M448,288h2.333v2.333H448Z",
    transform: "translate(-369 -232.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M448,352h2.333v2.333H448Z",
    transform: "translate(-369 -287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M448,320h2.333v2.333H448Z",
    transform: "translate(-369 -259.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M336,256h7v2.333h-7Z",
    transform: "translate(-273.333 -205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M336,288h7v2.333h-7Z",
    transform: "translate(-273.333 -232.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M336,320h7v2.333h-7Z",
    transform: "translate(-273.333 -259.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M408,256h2.333v2.333H408Z",
    transform: "translate(-334.833 -205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M408,288h2.333v2.333H408Z",
    transform: "translate(-334.833 -232.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M408,352h2.333v2.333H408Z",
    transform: "translate(-334.833 -287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M408,320h2.333v2.333H408Z",
    transform: "translate(-334.833 -259.667)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraderIcon);
export default __webpack_public_path__ + "static/media/trader_icon.f65c37de0c157a80befa93c7065ed5e7.svg";
export { ForwardRef as ReactComponent };